import React, {
  BlockquoteHTMLAttributes,
  DetailedHTMLProps,
  ReactNode,
} from 'react';

import { Icon } from '~/components/icon/Icon';
import { SvgIconNames } from '~/design-tokens/iconography/SvgIcons';

import * as S from './CustomBlockquote.styles';
import { BlockquoteType, extractBlockquote } from './utils';

const DEFAULT_ICON_COLOR = 'var(--viz-bullish)';
const DEFAULT_ICON_NAME: SvgIconNames = 'CheckmarkCircle';

const iconColors: Record<BlockquoteType, string> = {
  ERROR: 'var(--viz-bearish)',
  SUCCESS: 'var(--viz-bullish)',
};

const iconNames: Record<BlockquoteType, SvgIconNames> = {
  ERROR: 'ExclamationCircle',
  SUCCESS: 'CheckmarkCircle',
};

const formatBlockquoteString = (
  children: ReactNode
): { type: BlockquoteType; content: string[] } | null => {
  if (Array.isArray(children)) {
    const blockquoteString = children[1].props.children;

    if (typeof blockquoteString === 'string') {
      return extractBlockquote(blockquoteString);
    }
  }

  return null;
};

export const CustomBlockquote = ({
  children,
}: DetailedHTMLProps<
  BlockquoteHTMLAttributes<HTMLQuoteElement>,
  HTMLQuoteElement
>) => {
  const formattedBlockquote = formatBlockquoteString(children);

  if (formattedBlockquote) {
    const iconName = iconNames[formattedBlockquote.type] || DEFAULT_ICON_NAME;

    return (
      <S.StyledBlockquote>
        <Icon
          fillColor={iconColors[formattedBlockquote.type] || DEFAULT_ICON_COLOR}
          iconName={iconName}
          size={10.8}
        />
        <S.TextWrapper>
          {formattedBlockquote.content.map((text, i) => (
            <span key={`${text}${i}`}>{text}</span>
          ))}
        </S.TextWrapper>
      </S.StyledBlockquote>
    );
  }

  return formattedBlockquote;
};

CustomBlockquote.Styled = S;
